import * as React from "react";
import { SummaryDetailLabel } from "./SummaryDetailLabel";

type SummaryDetailBoxProps = {
  label: string;
  children: React.ReactNode;
  className?: string;
  colSpan?: number;
};

const colSpanClasses: Record<number, string> = {
  1: "col-span-2 xl:col-span-1",
  2: "col-span-2",
  3: "col-span-2 xl:col-span-3",
  4: "col-span-2 xl:col-span-4",
};

export const SummaryDetailBox: React.FC<SummaryDetailBoxProps> = ({ label, children, className = "", colSpan = 1 }) => {
  return (
    <div
      data-testid={`summary-detail-box-${label.toLowerCase()}`}
      className={`relative flex gap-8 rounded-md border border-solid border-slate-300 bg-white p-5 pb-3 ${colSpanClasses[colSpan] ?? ""} ${className}`}
    >
      <SummaryDetailLabel label={label} />
      {children}
    </div>
  );
};
